import { connect } from 'react-redux';

import GroupsTab from './GroupsTab';

import { currentUser } from '../../../../../core/selectors/user';
import {
  isInstructor,
  currentClassRoomId as getCurrrentClassRoomId,
} from '../../../../../core/selectors/classroom';
import {
  selectors as groupSelectors,
  operations as groupOperations,
} from '../../../../store/groups';

const mapStateToProps = (state) => {
  const user = currentUser(state);
  const isCurrentUserInstructor = isInstructor(state, user.objectId);
  const currentClassRoomId = getCurrrentClassRoomId(state);
  const noGroupSets =
    groupSelectors.groupSetsIds(state, currentClassRoomId).length === 0;

  return {
    isInstructor: isCurrentUserInstructor,
    noGroupSets,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onCreateSet: () => dispatch(groupOperations.openAddGroupSet),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupsTab);
